/**
 * Centralized service to handle all localStorage operations with multi-language support.
 */
export default class StorageService {
    /**
     * Get a namespaced key based on current language.
     * @param {string} key 
     * @returns {string}
     */
    static getKey(key) {
        return window.geoNerdApp.languageManager.getStorageKey(key);
    }

    /**
     * Save a value to localStorage.
     * @param {string} key 
     * @param {any} value 
     */
    static save(key, value) {
        const fullKey = this.getKey(key);
        if (typeof value === 'object') {
            localStorage.setItem(fullKey, JSON.stringify(value));
        } else {
            localStorage.setItem(fullKey, value);
        }
    }

    /**
     * Load a value from localStorage.
     * @param {string} key 
     * @param {any} defaultValue 
     * @returns {any}
     */
    static load(key, defaultValue = null) {
        const fullKey = this.getKey(key);
        const value = localStorage.getItem(fullKey);

        if (value === null) return defaultValue;

        try {
            // Try to parse as JSON, if it fails, return as string
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }

    /**
     * Remove a key from localStorage.
     * @param {string} key 
     */
    static remove(key) {
        localStorage.removeItem(this.getKey(key));
    }

    /**
     * Clear all keys for a specific game/category.
     * @param {string} prefix 
     */
    static clearByPrefix(prefix) {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes(prefix)) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(k => localStorage.removeItem(k));
    }
}
